export default function authHeader() {
  try {
    let userStr = localStorage.getItem('user');
    console.log('=== AUTH HEADER ===');
    console.log('User string from localStorage:', userStr ? 'Present' : 'Missing');
    
    if (!userStr) {
      console.log('No user in localStorage, returning basic headers');
      return {
        'Content-Type': 'application/json'
      };
    }

    let user = JSON.parse(userStr);
    console.log('Parsed user:', {
      username: user.username,
      hasToken: !!user.token,
      hasAccessToken: !!user.accessToken,
      tokenLength: user.token ? user.token.length : 0
    });
    
    // Vérifier si le token a expiré (si possible)
    if (user && user.token) {
      // Vérifier si le token est un JWT valide
      try {
        const tokenParts = user.token.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          const expiration = payload.exp * 1000; // Convertir en millisecondes
          
          console.log('Token expiration check:', {
            now: Date.now(),
            expiration: expiration,
            expired: expiration < Date.now()
          });
          
          // Si le token a expiré, supprimer l'utilisateur du localStorage
          if (expiration < Date.now()) {
            console.warn('Token expiré, déconnexion automatique');
            localStorage.removeItem('user');
            window.location.href = '/login'; // Redirection vers la page de connexion
            return { 'Content-Type': 'application/json' };
          }
        }
      } catch (e) {
        console.error('Erreur lors de la vérification du token:', e);
      }
      
      console.log('Returning headers with Bearer token');
      return { 
        'Authorization': 'Bearer ' + user.token,
        'Content-Type': 'application/json'
      };
    } else if (user && user.accessToken) {
      console.log('Returning headers with accessToken');
      return { 
        'Authorization': 'Bearer ' + user.accessToken,
        'Content-Type': 'application/json'
      };
    } else {
      console.log('No valid token found, returning basic headers');
      return {
        'Content-Type': 'application/json'
      };
    }
  } catch (error) {
    console.error('Erreur dans authHeader:', error);
    return {
      'Content-Type': 'application/json'
    };
  }
} 